import React, { useState, useEffect, useContext } from "react"

const FavoriteContext = React.createContext()

export const useFavorite = () => {
    return useContext( FavoriteContext )
}

function FavoriteProvider({ children, isGuest }) {
    const [ allowFavorite, setAllowFavorite ] = useState( false )

    useEffect(() => {
        isGuest ? setAllowFavorite( false ) : setAllowFavorite( true )
    }, [isGuest])

    return (
        <FavoriteContext.Provider value={allowFavorite} >
            { children }
        </FavoriteContext.Provider>
    )
}

export default FavoriteProvider
